import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import type { GeneralResp } from '@/models/GeneralResp';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 驗證手機 OTP 請求參數
 */
export interface IVerifyMobileParams {
    /** 驗證碼 (6位數字) */
    code: string;
}

/**
 * 驗證手機 OTP 回應
 */
export interface IVerifyMobileResponse extends GeneralResp {
    // GeneralResp 已包含 status, title, message, errorCode
}

/**
 * 登入 - 驗證手機 OTP 簡訊驗證碼 API
 *
 * @description 驗證用戶輸入的 6 位數字 OTP 驗證碼
 * @param params 驗證參數
 * @returns Promise<IVerifyMobileResponse>
 */
const VerifyMobile = (params: IVerifyMobileParams): Promise<IVerifyMobileResponse> => {
    const url = RouteUrlList.API_VerifyMobile.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return ApiClient.post(
        url,
        {
            code: params.code
        },
        config
    ).then((res: AxiosResponse<IVerifyMobileResponse>) => {
        return res.data;
    });
};

export default VerifyMobile;
